import React from 'react';
import { Link } from 'react-router-dom';
import { CircleHelp, ExternalLink, ShieldCheck } from 'lucide-react';
import { COMPANY_CONFIG } from '../config/constants';

function Footer() {
  return <footer className="border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
    <div className="mx-auto flex max-w-[1600px] flex-col gap-2 text-xs text-gray-500 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2"><span>© {new Date().getFullYear()} {COMPANY_CONFIG.name}</span><span className="hidden text-gray-300 sm:inline">•</span><span className="hidden sm:inline">Enterprise Resource Planning</span></div>
      <div className="flex flex-wrap items-center gap-4">
        <Link to="/hr-policies" className="inline-flex items-center gap-1 hover:text-[#2b3380]"><ShieldCheck size={13} /> Policies</Link>
        <Link to="/reports" className="inline-flex items-center gap-1 hover:text-[#2b3380]"><CircleHelp size={13} /> Reports</Link>
        {COMPANY_CONFIG.website && <a href={COMPANY_CONFIG.website.startsWith('http') ? COMPANY_CONFIG.website : `https://${COMPANY_CONFIG.website}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-[#2b3380]">Website <ExternalLink size={12} /></a>}
      </div>
    </div>
  </footer>;
}

export default Footer;
